import { TEMPLATES } from "utils/constants";
import NoLevels from "./NoLevels";

const Templates = {
  [TEMPLATES.B2B.THEMES.DEFAULT.PRODUCT_NO_LEVELS]: NoLevels,
};
export default Templates;
